import noodleApiClient, { ApiDefinition } from '@noodleApi';

type ThisApi = ApiDefinition['/invoices/{creatorId}/authorized-user-invoices']['GET'];

type Input = ThisApi['query'] & {
  creatorId: string;
  page?: number;
  perPage?: number;
};

const getEmployerPocInvoices = async ({
  creatorId,
  filter,
  startDate,
  endDate,
  search,
  page = 1,
  perPage = 25,
}: Input): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.get(`/invoices/${creatorId}/authorized-user-invoices`, {
    params: {
      endDate,
      filter,
      page,
      perPage,
      search,
      startDate,
    },
  });

  return response.data;
};

export default getEmployerPocInvoices;